
const postalCodeValidatorUS = (postcode) => {
    
    const zipFormat = new RegExp('^[0-9]{5}(?:-[0-9]{4})?$');
    return postcode && zipFormat.test(postcode);
};

export default postalCodeValidatorUS;
